module.exports = __webpack_public_path__ + "img/office2.be0c76e1.png";